import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import {
  api
} from "../api/all.js"
import {
  httpGet,
  httpPost,
  httpPostno,
  httpGetno
} from "../api"
import moment from "moment"
  import {
    ztreeToElementTree,
    recursion,
    uniqueArray,compare
  } from "../utils/index";
import {isObject} from '../lib/types'
import utils from "../utils/util";
const store = new Vuex.Store({
  state: {
    facemessage: {},
    flatsIndexwidth: '40vw',  // 首页数据页面的宽度
    fenquprojects: 0,  // 分区项目总数
    partitiontage: 0,
    nowareaTotal: 0,  // 当前分区设备数量
    locale: '',
    lockTypes:[1,21,41],
    control:[15],
    treeList:[],
    roomList:[],
    tenantId:1200,//localStorage.getItem('tenantId') || '100',
    selectoption: [],
    tagsList: [],
    cardList: [],
    collapse: false,
    lange: false,
    token: {
      refresh_token: "",
      access_token: ""
    },
    ms_username: '',
    collectUS: {
      houseSensor400: 0,
      lock200: 0,
      lock300: 0,
      site200: 0,
      site300: 0,
      site400: 0,
      userCount: 0
    },
    seriesData: {
      abnormalTotal: 0,
      batteryLevel1: 0,
      batteryLevel2: 0,
      batteryLevel3: 0,
      batteryLevel4: 0,
      batteryLevel5: 0,
      closeTotal: 0,
      offlineTotal: 0,
      onlineTotal: 0,
      openTotal: 0,
      projects: 0,
      total: 0
    },
    cdata: [0, 0, 0, 0, 0],
    tableData: {},
    currentPage: 1,
    currentPage1: 1,
    deviceList: [],
    roomAbout: [],
    deviceAbout: [],
    customerCode: "d39eaa7fc1f34190869608259133d2fb",
		conditionRoomAndPersonnel:[],
    analysis: {
      abnormalTotal: 0,
      batteryLevel1: 0,
      batteryLevel2: 0,
      batteryLevel3: 0,
      batteryLevel4: 0,
      batteryLevel5: 0,
      offlineTotal: 0,
      onlineTotal: 0,
      operationTotal: 0,
      projects: 0,
      total: 0,
    },
    statisticsDate:{},
    Statistics: {
      projectSum: 0,
      deviceSum: 0,
      bindingSum: 0,
      islineSum: 0,
      unlineSum: 0,
      lowElectricity: 0,
      openlook: 0,
      closelook: 0,
      openDoorlog: 0,
      closeDoorlog: 0,
      unlineList: [],
      fcDoorlog: 0,
      Processed: 0,
      allertLog: {
        openDoorlog: [0, 0, 0, 0, 0, 0, 0],
        closeDoorlog: [0, 0, 0, 0, 0, 0, 0],
        fcDoorlog: [0, 0, 0, 0, 0, 0, 0],
      },
      deviceBattery: [0, 0, 0],
      userinfo: {
        type: 1
      }
    },
		zNodes:[],
    enterpriseTree:[],
    enterpriselist:[],
    roomSum:0,
    allDeviceList:[],
      setting:{
          isScale:true,//是否进行全局适配
          sbtxSwiper: true,//设备提醒轮播
          ssyjSwiper:true,//实时预警轮播
          defaultOption: {
              step: 4.4, // 数值越大速度滚动越快
              hoverStop: true, // 是否开启鼠标悬停stop
              openWatch: true, // 开启数据实时监控刷新dom
              direction: 1, // 0向下 1向上 2向左 3向右
              limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
              singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
              singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
              waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
          },
          echartsAutoTime:3000,//echarts 图自动请求接口时间
      }
  },
  mutations: {
      updateSwiper(state, {val,type}) {
          state[type]=val
          localStorage.setItem('settingData',JSON.stringify({
              sbtxSwiper:state.sbtxSwiper,
              ssyjSwiper:state.ssyjSwiper,
              aztpSwiper:state.aztpSwiper,
              isScale:state.isScale
          }))
      },
      initSwipers(state){
          let flags = JSON.parse(localStorage.getItem('settingData'))
          // console.log(flags);
          if(flags && isObject(flags)){
              for (const key in flags) {
                  if (state.hasOwnProperty.call(flags, key)&&flags.hasOwnProperty.call(flags, key)) {
                      const element = flags[key];
                      state[key]=element
                  }
              }
          }
      },
		getConditionRoomAndPersonnel(state){
			let data = {};
			httpPost(data, api.onlyTenant).then((res) => {
				if(res.success){
					state.conditionRoomAndPersonnel = res.data.list
				}
			})
		},
    getTree(state) {
        let data = {
          // orderType:'name'
        };
        httpGet(data, api.getTree).then((res) => {
        if(res.success){
          res.data.sort()
          state.roomList =  res.data.sort(function(a,b){
            return a.id-b.id
          })
          let arrData = uniqueArray(res.data, "id")
           let arr = arrData.sort(function(a,b){
               return a.index-b.index
            })
          state.treeList = arr
          state.zNodes = ztreeToElementTree(arr, {});
          let roomSum = 0
          for(let i=0;i<arr.length;i++){
            if(arr[i].isRoom == 1){
              ++roomSum;
            }
          }
          state.roomSum = roomSum
        }
		})
	},
    getDeviceItems(state) {
      let data = {
        pageNum: 0,
        pageSize: 0,
        q: JSON.stringify({
          types: state.lockTypes
        })
      };
      httpPost(data, api.getDeviceItems).then((res) => {
        state.allDeviceList = res.data.list
      })
    },
    getEnterprise(state) {
      let data = {};
      httpGet(data, api.getEnterprise).then((res) => {
        if(res.success){
          res.data.list.map((li) => {
            li.pid = li.parentId;
          });
          state.enterpriselist = res.data.list
          state.enterpriseTree = ztreeToElementTree(res.data.list, {});
        }
      })
    },
    getselectoption(state, v) {
        return false;
      var userinfo = JSON.parse(localStorage.getItem("info"));
      var tenantId = userinfo.tenantId.split(',')
      console.log(tenantId)
      var arr = []
      httpGet('', api.getConfig).then(res => {
        console.log(res);
        if (res.success) {
          if(userinfo.type===0){
            arr=res.data.list
          }else{
            tenantId.map(lt => {
              var obj = res.data.list.filter(item => {return item.value==lt})[0]
              if(obj){
                arr.push(obj)
              }
            })
          }
          state.selectoption = arr
          localStorage.setItem('selectoption',JSON.stringify(arr))
        } else {
          this.$message.error("获取失败")
        }
      })
    },
    getuserInfo(state) {
      httpGet('', api.userInfo).then(res3 => {
        if (res3.success) {
          state.userinfo = res.data
        }
      })
    },
    settenantid(state) {
      return false;
      state.tenantId = localStorage.getItem('tenantId') || '100'
      // var tenantId = JSON.parse(localStorage.getItem("tenantId"));
      // if (tenantId) {
      //   state.tenantId = tenantId
      // } else {
      //   var userinfo = JSON.parse(localStorage.getItem("info"));
      //   tenantId = userinfo.tenantId.split(',')
      //   state.tenantId = tenantId[0]
      //   localStorage.setItem('tenantId', tenantId[0])
      // }
    },
    defaultsettenantid(state) {
      return false;
      var userinfo = JSON.parse(localStorage.getItem("info"));
      var tenantId = userinfo.tenantId.split(',')
      state.tenantId = tenantId[0]
      localStorage.setItem('tenantId', tenantId[0])
    },
    updateTenantId(state, p) {
      return false;
      state.tenantId = p
      localStorage.setItem('tenantId', p)
    },
    updatedata(state, p) {
      state.Statistics.openlook = p
    },
    getCardname(state) {
      var data = {
        pageNum: 0,
        pageSize: 0,
        assembly: "createAt desc",
		q:JSON.stringify({})
      };
      httpPost(data, api.getlistNum).then((res) => {
        if (res.success) {
          let data = utils.zlib_unzip(res.data)
          state.cardList =data
        } else {
          state.cardList = []
        }
      })
    },
    setanalysis(state, data) {
      state.analysis = data
    },
    // 查询关于房间数据
    getAboutRoom(state, count) {
      state.roomAbout = count
    },
    // 查询关于房间数据
    getAboutDevice(state, count) {
      state.deviceAbout = count
    },
    increment(state, count) {
      state.currentPage = count
    },
    increment1(state, count) {
      state.currentPage1 = count
    },
    deviceFun(state, list) {
      state.deviceList = list
    },
    getcollectUS(state) {

    },
    setUser(state, v) {
      state.seriesData = v;
    },
   async setUser1(state) {
      let ids = JSON.parse(localStorage.getItem('info')) //require('../../static/global.json');
      let tenantIdlist = ids.tenantId.split(',')
      const filteredNumbers = tenantIdlist.filter(li => li!= 100 && li!= 400)
      let tenantIds = filteredNumbers.join(',')
      //  let tenantIds= ids.tenantId//ids.tenantId.replace(/400,|,400|100,|,100/g, '')
      let lookStatistic=0
    httpGetno("", `/v1/statistics/all/analysis/${tenantIds}/1`).then((res) => {
          for(let key in res){
            lookStatistic+=res[key].total
          }
          localStorage.setItem("lookStatistic", lookStatistic)
      })
      httpGetno("", `/v1/statistics/all/analysis/${tenantIds}/-1`).then((res) => {
        console.log(state.tenantId);
          let deviceTotal = 0
        // if(state.tenantId != '100'){
        //     deviceTotal = 0
        //   for(let key in res){
        //     deviceTotal += res[key].total
        //     if(key == state.tenantId){
        //       state.nowareaTotal = res[key].total
        //       state.fenquprojects = res[key].projects
        //     }
        //   }
        //   state.partitiontage = Number((parseInt(state.nowareaTotal) / parseInt(deviceTotal) * 100).toFixed(2))
        // }else{
        //   state.nowareaTotal = 0
        //   state.fenquprojects = 0
        //   state.partitiontage = 0
        // }
        for(let key in res){
            deviceTotal += res[key].total
            if(key == state.tenantId){
                state.nowareaTotal = res[key].total
                state.fenquprojects = res[key].projects
            }
        }
        state.partitiontage = Number((parseInt(state.nowareaTotal) / parseInt(deviceTotal) * 100).toFixed(2))
        var datate = [0, 0, 0, 0, 0, 0, 0]
        var today = moment().format("YYYY-MM-DD")
        datate[6] = today
        datate[5] = moment().subtract('days', 1).format("YYYY/MM/DD")
        datate[4] = moment().subtract('days', 2).format("YYYY/MM/DD")
        datate[3] = moment().subtract('days', 3).format("YYYY/MM/DD")
        datate[2] = moment().subtract('days', 4).format("YYYY/MM/DD")
        datate[1] = moment().subtract('days', 5).format("YYYY/MM/DD")
        datate[0] = moment().subtract('days', 6).format("YYYY/MM/DD")
        var sum = [{
          order: datate[0],
          count: 0
        }, {
          order: datate[1],
          count: 0
        }, {
          order: datate[2],
          count: 0
        }, {
          order: datate[3],
          count: 0
        }, {
          order: datate[4],
          count: 0
        }, {
          order: datate[5],
          count: 0
        }, {
          order: datate[6],
          count: 0
        }]
        var array = []
        for (var i in res) {
          array.push(res[i])
        }
        var seriesData = {
          abnormalTotal: 0,
          batteryLevel1: 0,
          batteryLevel2: 0,
          batteryLevel3: 0,
          batteryLevel4: 0,
          batteryLevel5: 0,
          closeTotal: 0,
          offlineTotal: 0,
          onlineTotal: 0,
          openTotal: 0,
          projects: 0,
          total: 0,
          isAppBind:0,
        }
        array.map((li, index) => {
          if (index < array.length) {
            for (var key in seriesData) {
              seriesData[key] += li[key]
            }
          }
        })
        array.map((li, index) => {
          li.createAtS.map(lt => {
            var order = moment(lt).format("YYYY/MM/DD")
            if (order == datate[0]) {
              sum[0].count += 1
            } else if (order == datate[1]) {
              sum[1].count += 1
            } else if (order == datate[2]) {
              sum[2].count += 1
            } else if (order == datate[3]) {
              sum[3].count += 1
            } else if (order == datate[4]) {
              sum[4].count += 1
            } else if (order == datate[5]) {
              sum[5].count += 1
            } else if (order == datate[6]) {
              sum[6].count += 1
            }
          })
        })
        var cdata = state.cdata
        cdata[0] = (parseInt(seriesData.batteryLevel1) / parseInt(seriesData.total) * 100).toFixed(2);
        cdata[1] = (parseInt(seriesData.batteryLevel2) / parseInt(seriesData.total) * 100).toFixed(2);
        cdata[2] = (parseInt(seriesData.batteryLevel3) / parseInt(seriesData.total) * 100).toFixed(2);
        cdata[3] = (parseInt(seriesData.batteryLevel4) / parseInt(seriesData.total) * 100).toFixed(2);
        cdata[4] = (parseInt(seriesData.batteryLevel5) / parseInt(seriesData.total) * 100).toFixed(2);
        // seriesData['lookStatistic']=lookStatistic
        state.cdata = cdata
        state.seriesData = seriesData
        var collectUS = {
          houseSensor400: 0,
          lock200: 0,
          lock300: 0,
          site200: 0,
          site300: 0,
          site400: 0,
          userCount: 0
        }
        httpGetno("", `/v1/statistics/all/collectUSA/${tenantIds}`).then((res) => {
          state.collectUS = res
          collectUS = res
          var ary1 = []
          let locksum = 0
          for(let o in res){
            let n = o.indexOf('lock')
            if(n != -1){
              ary1 = ary1.concat(res[o])
            }
          }
            let statisticsDate = {
                cdata: cdata,
                seriesData: seriesData,
                collectUS: collectUS,
                collectOpenLock: {},
                weekopenlock: [],
                addDeviceWeek: sum,
            }
            state.statisticsDate=statisticsDate
            localStorage.removeItem("statisticsDate")
            localStorage.setItem("statisticsDate", JSON.stringify(statisticsDate))
            tenantIds = tenantIds.split(',')
          const tenantIdsTwo = tenantIds.filter(li => li!= 100 && li!= 400)
          httpGetno("", `/v1/statistics/collect/openLock/${tenantIdsTwo}`).then((res1) => {
            let ary = []
            for(let o in res1){
                let m=o.indexOf('week')
              if(m!=-1){
                ary = ary.concat(res1[o])
              }
            }
              let objArr = [];
            ary.forEach(function(v, i){
              const result = objArr.findIndex((ev) => {
                  return ev.order === v.order;
              })
              if(result!=-1){
                objArr[result].count+=v.count
              }else{
                objArr.push(v)
              }
            })
              console.log('seriesData-------',seriesData)
            var sortArry=objArr.sort(compare('order','positive'))
            setTimeout(()=>{
              var statisticsDate = {
                cdata: cdata,
                seriesData: seriesData,
                collectUS: collectUS,
                collectOpenLock: res1,
                weekopenlock: sortArry,
                addDeviceWeek: sum,
              }
              state.statisticsDate=statisticsDate
              localStorage.removeItem("statisticsDate")
              localStorage.setItem("statisticsDate", JSON.stringify(statisticsDate))
            },500)
          })
        });
      });
    },
    selectlanguage(state) {
      if (state.lange) {
        state.lange = false
        sessionStorage.setItem("lange", false)
      } else {
        state.lange = true
        sessionStorage.setItem("lange", true)

      }
    },
    delTagsItem(state, data) {
      state
        .tagsList
        .splice(data.index, 1);
    },
    setTagsItem(state, data) {
      state
        .tagsList
        .push(data)
    },
    clearTags(state) {
      state.tagsList = []
    },
    closeTagsOther(state, data) {
      state.tagsList = data;
    },
    closeCurrentTag(state, data) {
      for (let i = 0, len = state.tagsList.length; i < len; i++) {
        const item = state.tagsList[i];
        if (item.path === data.$route.fullPath) {
          if (i < len - 1) {
            data
              .$router
              .push(state.tagsList[i + 1].path);
          } else if (i > 0) {
            data
              .$router
              .push(state.tagsList[i - 1].path);
          } else {
            data
              .$router
              .push("/");
          }
          state
            .tagsList
            .splice(i, 1);
          break;
        }
      }
    },
    // 侧边栏折叠
    hadndleCollapse(state, data) {
      state.collapse = data;
    }
  },
  actions: {},
  modules: {}
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js